export const chartSearchDurationsOptions = [
  { width: "w-[85px]", value: 0, name: "اليوم" },
  { width: "w-[114px]", value: 1, name: "آخر اسبوع" },
  { width: "w-[118px]", value: 2, name: "آخر 14 يوم " },
  { width: "w-[118px]", value: 3, name: "آخر  شهر " },
  { width: "w-[126px]", value: 4, name: "آخر 3 شهور " },
  { width: "w-[98px]", value: 5, name: "آخر  عام " },
];

export const chartDefaultWeekDataObject = {
  total: 0,
  weekCounts: [],
  comparisonPercentage: 0,
};

export const chartDayTranslations = {
  sunday: "الاحد",
  monday: "الاثنين",
  tuesday: "الثلاثاء",
  wednesday: "الاربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
};
